import React, { Component, Fragment } from 'react';
import { localize } from 'react-localize-redux';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import { CSSTransitionGroup } from 'react-transition-group';

import Tasks from './tasks/Tasks';
import TicketHeaderTabs from './TicketHeaderTabs';
import TicketDetails from './TicketDetails';
import TicketHistory from './TicketHistory';

import { hostIsCapreit } from 'helpers/CurrentWindowLocation';

import { MaintenanceTemplateStatus } from 'components/shared/StatusHelper';
import FooterButtons from 'components/shared/FooterButtons';
import StatusTag from 'components/ui/StatusTag';
import FlatButton from 'material-ui/FlatButton';
import Auth from 'j-toker';

const pageViewHeaders = {
  DETAILS: { name: 'details', formName: 'edit_ticket_form' },
  EVENTS: { name: 'events', formName: '' },
  TASKS: { name: 'tasks', formName: 'add_task_form' },
};

class TicketDetailsOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openView: pageViewHeaders.DETAILS.name,
      formName: pageViewHeaders.DETAILS.formName,
      confirmationDialogOpen: false,
      cancellationReason: '',
    };
  }

  pageView = pageToView => {
    this.setState({
      openView: pageToView.name,
      formName: pageToView.formName,
    });
  };

  toggleDialog = () => {
    this.setState({
      confirmationDialogOpen: !this.state.confirmationDialogOpen,
    });
  };

  deleteTicket = () => {
    this.props.deleteAction(this.state.cancellationReason).then(() => {
      this.toggleDialog();
    });
  };

  cancellationOnChange = (_e, _index, newValue) => {
    if (!newValue) {
      return;
    }

    this.setState({ cancellationReason: newValue });
  };

  render() {
    const { handleSubmit, toggleDrawer, translate, maintenanceTicket } = this.props;

    const isCapreitMaintenanceStaff =
      hostIsCapreit() && Auth.user.type.toLowerCase() === 'maintenance';
    const actions = [
      <FlatButton
        label={translate('landlordPortal.ticketDetailsOverview.close')}
        style={{ float: 'left' }}
        primary={true}
        onClick={this.toggleDialog}
      />,
      <FlatButton
        label={translate('landlordPortal.ticketDetailsOverview.cancelTicket')}
        primary={true}
        keyboardFocused={true}
        onClick={this.deleteTicket}
      />,
    ];

    return (
      <Fragment>
        <div
          className="row"
          style={{
            width: '100%',
            height: '65px',
            padding: '10px',
            backgroundColor: 'white',
          }}
        >
          {!this.props.showRecurrance && (
            <h2
              style={{
                textAlign: 'center',
                margin: '8px 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {translate('landlordPortal.ticketDetailsOverview.ticketNo', {
                ticketNumber: maintenanceTicket.ticket_number,
              })}
              &nbsp;
              <StatusTag status={maintenanceTicket.status} topMargin="-10px" />
            </h2>
          )}
          {this.props.showRecurrance && (
            <h2 style={{ textAlign: 'center', margin: '8px 0' }}>
              {maintenanceTicket.schedule_name}
              &nbsp;
              <MaintenanceTemplateStatus
                status={maintenanceTicket.schedule_is_active}
                style={{ fontSize: '41%' }}
              />
            </h2>
          )}
        </div>
        <TicketHeaderTabs
          pageView={this.pageView}
          openView={this.state.openView}
          maintenanceTicketTasks={maintenanceTicket.tasks}
        />
        <div
          onSubmit={handleSubmit}
          style={{
            padding: '15px',
            height: 'calc(100% - 155px)',
            overflow: 'scroll',
            backgroundColor: '#fbfbfb',
          }}
        >
          <CSSTransitionGroup
            transitionName="fade_out_buttons"
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}
          >
            {this.state.openView === pageViewHeaders.DETAILS.name && (
              <TicketDetails
                actions={actions}
                confirmationDialogOpen={this.state.confirmationDialogOpen}
                toggleDialog={this.toggleDialog}
                hostIsBoardwalk={hostIsBoardwalk()}
                cancellationReason={this.state.cancellationReason}
                cancellationOnChange={this.cancellationOnChange}
                maintenanceTicket={maintenanceTicket}
                showRecurrance={this.props.showRecurrance}
                companyPreferences={this.props.companyPreferences}
                updateTicket={this.props.updateTicket}
              />
            )}

            {this.state.openView === pageViewHeaders.TASKS.name && (
              <Tasks
                hostIsBoardwalk={hostIsBoardwalk()}
                createOrUpdateTask={this.props.createOrUpdateTask}
                deleteTask={this.props.deleteTask}
                maintenanceTicket={maintenanceTicket}
              />
            )}

            {this.state.openView === pageViewHeaders.EVENTS.name && (
              <TicketHistory maintenanceTicket={this.props.maintenanceTicket} />
            )}
          </CSSTransitionGroup>
        </div>
        <div
          style={{
            flex: '0 0 auto',
            margin: '8px 4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <FooterButtons
            backName={translate('landlordPortal.ticketDetailsOverview.close')}
            formName={this.state.formName}
            submitName={translate('landlordPortal.ticketDetailsOverview.save')}
            backAction={toggleDrawer}
            hideSubmitButton={isCapreitMaintenanceStaff}
          />
        </div>
      </Fragment>
    );
  }
}

export default localize()(TicketDetailsOverview);
